import { LibService } from './libService';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class LevelService {
  baseApi = environment.rootApiFoundation;

  constructor(public libService: LibService) { }

  getAllLevels(): Observable<any> {
    return this.libService.getData<any>(this.baseApi, 'levels/');
  }
}
